import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Center, Flex, Icon } from '@chakra-ui/react';
import { NotificationTime } from '../../components/Time';
import { MeetingDetailsContainer, NotificationMessage } from './components';
import { Calendar } from '@kula-ai/icons-core';
import { Hackerrank } from '@/assets/icons/ats';

const InterviewCancelled = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const {
    candidate,
    interview_name,
    interview_url,
    job_name,
    interview_location_enum,
  } = data;
  const { name: candidateName, url } = candidate;
  const contact_id = url.split('/').pop();
  const interview_id = interview_url.split('/').pop();

  const messageData = {
    interview: {
      name: interview_name,
      url: `/interviews/${interview_id}`,
    },
    candidate: {
      name: candidateName,
      url: `/candidates/${contact_id}`,
    },
    job: {
      name: job_name,
    },
    interview_location_enum: interview_location_enum,
  };
  return (
    <Flex alignItems="baseline" gap="6px">
      <Center
        minW="34px"
        h="34px"
        borderRadius="sm"
        bg={
          interview_location_enum === 'hackerrank' ? 'black' : 'pastel-1-light'
        }
      >
        {interview_location_enum === 'hackerrank' ? (
          <Icon as={Hackerrank} color="ats-primary" />
        ) : (
          <Calendar
            size={16}
            color="var(--kula-colors-pastel-1-dark)"
            className="kula-icon"
          />
        )}
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <NotificationMessage
          template="INTERVIEW_CANCELED"
          data={messageData}
          onClose={onClose}
          notification={notification}
        />
        <MeetingDetailsContainer data={data} />
        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const InterviewCancelledNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <InterviewCancelled notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
